import { apiCall } from './gqlClient';

const CHECKRESERVATIONOVERLAP_QUERY = `
  query checkReservationOverlap($subServiceId: Int!, $resourceId: Int!, $dateTimeFrom: DateTime!, $duration: Int, $customerId: Int, $email: String) {
    checkReservationOverlap(subServiceId: $subServiceId, resourceId: $resourceId, dateTimeFrom: $dateTimeFrom, duration: $duration, customerId: $customerId, email: $email)
    {
      hasOverlap
      ...fragments
    }
  }`;

export const checkReservationOverlapApiCall = async ({subServiceId, resourceId, dateTimeFrom, duration, customerId, email}, fragments = null) => apiCall({ query: CHECKRESERVATIONOVERLAP_QUERY, variables: {subServiceId, resourceId, dateTimeFrom, duration, customerId, email}, fragments });

const GETRESERVATIONPRICE_QUERY = `
  query getReservationPrice($subServiceId: Int!) {
    getReservationPrice(subServiceId: $subServiceId)
    {
      price
			discount
			priceWithoutDiscount
			userHasMembership
			waitingList
      ...fragments
    }
  }`;

export const getReservationPriceApiCall = async ({subServiceId}, fragments = null) => apiCall({ query: GETRESERVATIONPRICE_QUERY, variables: {subServiceId}, fragments });

const GETCUSTOMERSSUBSERVICERESERVATIONS_QUERY = `
  query getCustomersSubserviceReservations($subserviceId: Int!, $userId: Int, $customerId: Int) {
    getCustomersSubserviceReservations(subserviceId: $subserviceId, userId: $userId, customerId: $customerId)
  }`;

export const getCustomersSubserviceReservationsApiCall = async ({subserviceId, userId, customerId}, ) => apiCall({ query: GETCUSTOMERSSUBSERVICERESERVATIONS_QUERY, variables: {subserviceId, userId, customerId}});

const GETRESERVATIONSFORMULTIPLECANCEL_QUERY = `
  query getReservationsForMultipleCancel($request: ReservationsForCancelInput!) {
    getReservationsForMultipleCancel(request: $request)
  }`;

export const getReservationsForMultipleCancelApiCall = async ({request}, ) => apiCall({ query: GETRESERVATIONSFORMULTIPLECANCEL_QUERY, variables: {request}});

const GETRESERVATIONPRESENCE_QUERY = `
  query getReservationPresence($reservationId: Int!) {
    getReservationPresence(reservationId: $reservationId)
    {
      id
			presence
      ...fragments
    }
  }`;

export const getReservationPresenceApiCall = async ({reservationId}, fragments = null) => apiCall({ query: GETRESERVATIONPRESENCE_QUERY, variables: {reservationId}, fragments });

const CREATERESERVATION_QUERY = `
  mutation createReservation($request: CreateReservationInput) {
    createReservation(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const createReservationApiCall = async ({request}, fragments = null) => apiCall({ query: CREATERESERVATION_QUERY, variables: {request}, fragments });

const CREATEMULTIPLERESERVATION_QUERY = `
  mutation createMultipleReservation($request: CreateMultipleReservationInput!) {
    createMultipleReservation(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const createMultipleReservationApiCall = async ({request}, fragments = null) => apiCall({ query: CREATEMULTIPLERESERVATION_QUERY, variables: {request}, fragments });

const CREATERESERVATIONASANONYMOUS_QUERY = `
  mutation createReservationAsAnonymous($subServiceId: Int!, $resourceId: Int!, $dateTimeFrom: DateTime!, $email: String!, $onlyBook: Boolean, $firstname: String, $lastname: String, $phone: String) {
    createReservationAsAnonymous(subServiceId: $subServiceId, resourceId: $resourceId, dateTimeFrom: $dateTimeFrom, email: $email, onlyBook: $onlyBook, firstname: $firstname, lastname: $lastname, phone: $phone)
    {
      id
			message
			success
			amount
			amountCents
			clientSecret
			stripeAccount
			offerId
			productId
      ...fragments
    }
  }`;

export const createReservationAsAnonymousApiCall = async ({subServiceId, resourceId, dateTimeFrom, email, onlyBook, firstname, lastname, phone}, fragments = null) => apiCall({ query: CREATERESERVATIONASANONYMOUS_QUERY, variables: {subServiceId, resourceId, dateTimeFrom, email, onlyBook, firstname, lastname, phone}, fragments });

const CONFIRMRESERVATION_QUERY = `
  mutation confirmReservation($code: JSON!) {
    confirmReservation(code: $code)
  }`;

export const confirmReservationApiCall = async ({code}, ) => apiCall({ query: CONFIRMRESERVATION_QUERY, variables: {code}});

const UPDATERESERVATION_QUERY = `
  mutation updateReservation($request: ReservationUpdateInput!) {
    updateReservation(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateReservationApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATERESERVATION_QUERY, variables: {request}, fragments });

const ACTIVATERESERVATION_QUERY = `
  mutation activateReservation($reservationId: Int!) {
    activateReservation(reservationId: $reservationId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const activateReservationApiCall = async ({reservationId}, fragments = null) => apiCall({ query: ACTIVATERESERVATION_QUERY, variables: {reservationId}, fragments });

const CANCELRESERVATION_QUERY = `
  mutation cancelReservation($reservationId: Int!) {
    cancelReservation(reservationId: $reservationId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const cancelReservationApiCall = async ({reservationId}, fragments = null) => apiCall({ query: CANCELRESERVATION_QUERY, variables: {reservationId}, fragments });

const CHANGEUSERRESERVATIONSNUMBER_QUERY = `
  mutation changeUserReservationsNumber($id: Int!, $numberOfReservations: Int!, $action: Boolean!, $startTime: DateTime, $endTime: DateTime) {
    changeUserReservationsNumber(id: $id, numberOfReservations: $numberOfReservations, action: $action, startTime: $startTime, endTime: $endTime)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const changeUserReservationsNumberApiCall = async ({id, numberOfReservations, action, startTime, endTime}, fragments = null) => apiCall({ query: CHANGEUSERRESERVATIONSNUMBER_QUERY, variables: {id, numberOfReservations, action, startTime, endTime}, fragments });

const CHANGEUSERRESERVATIONPRESENCE_QUERY = `
  mutation changeUserReservationPresence($reservationId: Int!, $presence: String!) {
    changeUserReservationPresence(reservationId: $reservationId, presence: $presence)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const changeUserReservationPresenceApiCall = async ({reservationId, presence}, fragments = null) => apiCall({ query: CHANGEUSERRESERVATIONPRESENCE_QUERY, variables: {reservationId, presence}, fragments });

const CANCELMULTIPLERESERVATIONSBYIDS_QUERY = `
  mutation cancelMultipleReservationsByIds($reservationIds: [Int]!) {
    cancelMultipleReservationsByIds(reservationIds: $reservationIds)
  }`;

export const cancelMultipleReservationsByIdsApiCall = async ({reservationIds}, ) => apiCall({ query: CANCELMULTIPLERESERVATIONSBYIDS_QUERY, variables: {reservationIds}});

const UPDATERESERVATIONSERVICE_QUERY = `
  mutation updateReservationService($request: ReservationUpdateServiceInput!) {
    updateReservationService(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateReservationServiceApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATERESERVATIONSERVICE_QUERY, variables: {request}, fragments });
